import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Container, Main, ResponsiveContainer } from "../components/common";
import ProductCardProd from "../components/ProductCardProd";
import StartingModal from "../components/StartingModal";
import AppContext from "../context/AppContext";

function Home(props) {
  const history = useHistory();
  const [profile, setProfile] = useState(null);
  const [trailActivated, setTrailActivated] = useState(false);
  const context = useContext(AppContext);

  useEffect(() => {
    console.log("Context inside -> ", context.firstLogin);
    const resp = context.token;
    if (!resp) return;
    const respJSON = JSON.parse(resp);
    setProfile({
      name: respJSON.UserData.Name,
    });
    // if (productStage.bank_connect != "" && productStage.device_connect == "") {
    //   history.push("./bankconnect");
    //   console.log("imsakl");
    // } else if (
    //   productStage.bank_connect == "" &&
    //   productStage.device_connect != ""
    // ) {
    //   history.push("./deviceconnect");
    // }
  }, []);

  const startTrial = async () => {
    let fT = context.token;
    const ftData = JSON.parse(fT);
    var myHeaders = new Headers();
    myHeaders.append("token", ftData.Token);
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
    };

    let response = await fetch(
      "https://dashboardapi.finbox.in/v1/user/starttrial",
      requestOptions
    );
    const result = await response.text();
    const json = JSON.parse(result);
    if (json.Status) {
      setTrailActivated(true);
    } else {
      setTrailActivated(false);
      alert(json.Error);
    }
  };

  return (
    <>
      {context.firstLogin ? (
        <StartingModal
          trailActivated={trailActivated}
          onPrimaryClick={() => startTrial()}
          onSecondaryClick={() =>
            window.open(
              "https://support643206.typeform.com/to/TZ0Joj",
              "_blank"
            )
          }
          onExploreClick={() => window.location.reload()}
          onFailedAction={() =>
            window.open(
              "https://support643206.typeform.com/to/TZ0Joj",
              "_blank"
            )
          }
        />
      ) : (
        ""
      )}
      {profile && (
        <Main style={{ background: "#f9f9f9" }}>
          <Container>
            <>
              <div style={{ margin: "40px 0 30px 0", width: "100%" }}/>
              <span style={{fontSize: "34px", fontWeight: "500", lineHeight: "45px", width: "50%", marginLeft: "auto", marginRight: "auto", textAlign:"center"}}>
                {profile.name}! What product dashboard do you wish to work on?
              </span>
              <div style={{display: "flex", justifyContent: "center", marginTop: "7%"}}>
                <ProductCardProd
                  src="https://finbox-cdn.s3.ap-south-1.amazonaws.com/assets/dashboard/signup2.svg"
                  alt="BankConnect"
                  title="BankConnect"
                  desc={
                    <>
                    BankConnect enriches transaction data from bank account statements.
                    <br />
                    Users can upload PDF manually or automatically via account aggregtor or net banking login.
                    </>
                  }
                  buttonText="Explore BankConnect"
                  onClick={() => history.push("/bankconnect")}
                />
                <div style={{width: 1, height: 380, background: "#B1B1B1B2"}}></div>
                <ProductCardProd
                  src="https://finbox-cdn.s3.ap-south-1.amazonaws.com/assets/dashboard/dcempty.svg"
                  alt="DeviceConnect"
                  title="DeviceConnect"
                  desc={
                    <>
                    DeviceConnect enriches mobile device data for customer onboarding, underwriting and collections via our DeviceConnect integration.
                    <br />
                    </>
                  }
                  buttonText="Explore DeviceConnect"
                  onClick={() => history.push("/deviceconnect")}
                />
              </div>
            </>
          </Container>
        </Main>
      )}
    </>
  );
}
export default Home;
